// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"6f7f9e76","239":"45a85985","389":"5a0726d2","455":"dd3d5eed","977":"b18ff127"}[chunkId] + ".chunk.js";
};